<template>
  <div class="imprint-color">
    <div class="imprint-color__colors">
      <div class="imprint-color__left">
        <strong> Please select at least one color</strong>
        <div class="imprint-color__list">
          <button
            :title="color.Name"
            class="color-item"
            :class="{
              'is-active':
                imprintMethodModel.decorationMethod.selectedStandardColors.includes(
                  color
                )
            }"
            v-for="(color, index) in displayColors"
            @click="onStandardColorClick(color)"
            :key="index">
            <i class="color-thumb" :style="{ 'background-color': color.Color }"
              ><img
                class="close"
                src="//img66.anypromo.com/WebSite2016/ImageResource/color_close.png"
                style="display: none" />
              <img
                src="//img66.anypromo.com/WebSite2016/ImageResource/na.gif"
                style="padding-top: 1px"
                v-if="color.Color == ''"
            /></i>
          </button>
        </div>
        <div
          class="imprint-color__more-color"
          v-show="
            imprintMethodModel.decorationMethod.DisplayColors.length > 35 &&
            state.isViewMoreVisible
          ">
          <ap-button text @click="onShowViewMoreClick"
            >More colors...</ap-button
          >
        </div>
      </div>
      <div
        class="imprint-color__right"
        v-if="imprintMethodModel.decorationMethod.PMSNotAvailable">
        <strong>PMS Colors:</strong
        ><input
          type="text"
          placeholder="(example:123)"
          @keyup="onEnterPms($event)"
          v-model="state.pmsSearch"
          class="pms-color-input" />
        <div class="pms-color-list" v-show="state.pmsMatch.length > 0">
          <div
            class="pms-color-item"
            v-for="color in state.pmsMatch"
            :key="color.Name"
            @click="onSelectPmsColor(color)">
            <div
              class="color"
              :style="{ 'background-color': color.Color }"></div>
            <div class="title">{{ color.Name }}</div>
          </div>
          <div class="pms-color-tips">Please click an option to select</div>
        </div>
        <div class="pms-color-selected-list">
          <button
            :title="color.Name"
            class="color-item is-active"
            v-for="(color, index) in imprintMethodModel.decorationMethod
              .selectedPmsColors"
            @click="onRemovePmsColor(color)"
            :key="index">
            <i class="color-thumb" :style="{ 'background-color': color.Color }"
              ><img
                class="close"
                src="//img66.anypromo.com/WebSite2016/ImageResource/color_close.png"
                style="display: none" />
              <img
                src="//img66.anypromo.com/WebSite2016/ImageResource/na.gif"
                style="padding-top: 1px"
                v-if="color.Color == ''"
            /></i>
          </button>
        </div>
      </div>
    </div>

    <div
      class="imprint-color__selected-color clearfix"
      v-show="imprintMethodModel.decorationMethod.selectedColors.length > 0">
      <span class="fs-13">Selected Colors:</span>
      <div class="pl-10">
        <div class="table border">
          <dl
            class="table-tr"
            v-for="color in imprintMethodModel.decorationMethod.selectedColors"
            :key="color.Name">
            <dd class="table-td td-spec-img">
              <div class="color-item size20x20">
                <div
                  class="color-thumb"
                  :style="{ 'background-color': color.Color }"></div>
              </div>
            </dd>
            <dd class="table-td td-spec-qty">
              <div class="color-name fs-13">
                {{ color.Name }}
              </div>
            </dd>
            <dd class="table-td td-spec-btn fs-13">
              <ap-button
                text
                class="btn-remove"
                @click="onRemoveSelectedColor(color)"
                >Delete</ap-button
              >
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, type PropType, reactive, ref } from 'vue'
import { getImprintMaxColors, useWindow } from '../../composables'
import { ImprintMethodModel } from '../../model'
import { useApp } from '../../store/modules/app'
import { useImprintMethod } from '../../store/modules/imprintMethod'
import { OrderType, type PMSColor } from '../../types'
import { ApButton } from '@anypromo/components-pc'

const props = defineProps({
  imprintMethodModel: {
    type: Object as PropType<ImprintMethodModel>,
    default: {} as unknown
  }
})

const emit = defineEmits(['max-color-error', 'click'])

const appState = useApp()
const imprintMethodState = useImprintMethod()

const { pmsColorList } = useWindow()

const state = reactive<{
  isViewMoreVisible: boolean
  // PMS搜索结果
  pmsMatch: PMSColor[]
  // pms color输入框内容
  pmsSearch: string
}>({
  isViewMoreVisible: true,
  // PMS搜索结果
  pmsMatch: [],
  // pms color输入框内容
  pmsSearch: ''
})

const displayColors = computed(() =>
  state.isViewMoreVisible
    ? props.imprintMethodModel.decorationMethod.DisplayColors.filter(
        (val, index) => index < 35
      )
    : props.imprintMethodModel.decorationMethod.DisplayColors
)

const onShowViewMoreClick = () => {
  state.isViewMoreVisible = false
}

const onStandardColorClick = (color: PMSColor) => {
  const { imprintMethodModel } = props

  let maxColors = imprintMethodModel.decorationMethod.MaxColors
  // 获取所选的颜色个数
  var selectedColorNum = 0
  imprintMethodState.getSelectedList.forEach((item) => {
    selectedColorNum += item.decorationMethod.selectedColors.length
  })

  // 计算当前price
  var priceList = appState.getCurrentPriceList
  var allMaxColors = getImprintMaxColors(priceList)
  if (allMaxColors === 0) allMaxColors = 999

  // 如果是spec sample，设置最多可选颜色数量是1
  if (appState.getOrderType === OrderType.SpecSample) maxColors = 1

  if (
    maxColors === 1 &&
    (props.imprintMethodModel.decorationMethod.selectedColors.length === 1 ||
      selectedColorNum < allMaxColors)
  ) {
    // 如果只有一个颜色，那就替换颜色
    if (
      imprintMethodModel.decorationMethod.selectedStandardColors.includes(color)
    ) {
      // 如果只能选一个颜色，选中当前的就取消其他的
      imprintMethodModel.decorationMethod.selectedStandardColors.splice(0)
      imprintMethodModel.decorationMethod.selectedColors.splice(0)
      imprintMethodModel.decorationMethod.selectedPmsColors.splice(0)
    } else {
      // 如果只能选一个颜色，选中当前的就取消其他的
      imprintMethodModel.decorationMethod.selectedStandardColors.splice(0)
      imprintMethodModel.decorationMethod.selectedColors.splice(0)
      imprintMethodModel.decorationMethod.selectedPmsColors.splice(0)

      // 如果当前颜色没被选中
      imprintMethodModel.decorationMethod.selectedStandardColors.push(color)
      imprintMethodModel.decorationMethod.selectedColors.push(color)
    }
  } else if (
    allMaxColors > 0 &&
    selectedColorNum >= allMaxColors &&
    imprintMethodModel.decorationMethod.selectedColors.includes(color) === false
  ) {
    emit('max-color-error', 'Max ' + allMaxColors + ' Imprint colors.')
  } else if (
    imprintMethodModel.decorationMethod.selectedColors.length < maxColors &&
    imprintMethodModel.decorationMethod.selectedStandardColors.includes(
      color
    ) === false
  ) {
    imprintMethodModel.decorationMethod.selectedStandardColors.push(color)
    imprintMethodModel.decorationMethod.selectedColors.push(color)
  } else if (
    imprintMethodModel.decorationMethod.selectedColors.length <= maxColors &&
    imprintMethodModel.decorationMethod.selectedStandardColors.includes(color)
  ) {
    const index =
      imprintMethodModel.decorationMethod.selectedStandardColors.indexOf(color)
    const indexForSelected =
      imprintMethodModel.decorationMethod.selectedColors.indexOf(color)

    imprintMethodModel.decorationMethod.selectedStandardColors.splice(index, 1)
    imprintMethodModel.decorationMethod.selectedColors.splice(
      indexForSelected,
      1
    )
  } else {
    emit(
      'max-color-error',
      'Max ' +
        imprintMethodModel.decorationMethod.MaxColors +
        ' Imprint colors.'
    )
  }
  emit('click')
}

const onSelectPmsColor = (color: PMSColor) => {
  const { imprintMethodModel } = props

  let maxColors = imprintMethodModel.decorationMethod.MaxColors
  // 获取所选的颜色个数
  let selectedColorNum = 0
  imprintMethodState.getSelectedList.forEach((item) => {
    selectedColorNum += item.decorationMethod.selectedColors.length
  })

  // 计算当前price
  const priceList = appState.getCurrentPriceList
  var allMaxColors = getImprintMaxColors(priceList)
  if (allMaxColors === 0) allMaxColors = 999

  // 如果是spec sample，设置最多可选颜色数量是1
  if (appState.getOrderType === OrderType.SpecSample) maxColors = 1

  if (
    maxColors === 1 &&
    (props.imprintMethodModel.decorationMethod.selectedColors.length === 1 ||
      selectedColorNum < allMaxColors)
  ) {
    // 如果只有一个颜色，那就替换颜色
    imprintMethodModel.decorationMethod.selectedStandardColors.splice(0)
    imprintMethodModel.decorationMethod.selectedColors.splice(0)
    imprintMethodModel.decorationMethod.selectedPmsColors.splice(0)

    imprintMethodModel.decorationMethod.selectedPmsColors.push(color)
    imprintMethodModel.decorationMethod.selectedColors.push(color)
    // 先把搜索结果删掉
    state.pmsMatch.splice(0)
    state.pmsSearch = ''
  } else if (
    allMaxColors > 0 &&
    selectedColorNum >= allMaxColors &&
    props.imprintMethodModel.decorationMethod.selectedPmsColors.includes(
      color
    ) === false
  ) {
    // ec.dialog.alert('The max colors for imprint method is  ' + allMaxColors + '.', 'Max Colors');
    emit('max-color-error', 'Max ' + allMaxColors + ' Imprint colors.')
  } else if (
    imprintMethodModel.decorationMethod.selectedColors.length < maxColors &&
    imprintMethodModel.decorationMethod.selectedPmsColors.includes(color) ===
      false
  ) {
    imprintMethodModel.decorationMethod.selectedPmsColors.push(color)
    imprintMethodModel.decorationMethod.selectedColors.push(color)
    // 先把搜索结果删掉
    state.pmsMatch.splice(0)
    state.pmsSearch = ''
  } else if (
    imprintMethodModel.decorationMethod.selectedColors.length <= maxColors &&
    imprintMethodModel.decorationMethod.selectedPmsColors.indexOf(color) !== -1
  ) {
    var index =
      imprintMethodModel.decorationMethod.selectedPmsColors.indexOf(color)
    var indexForSelected =
      imprintMethodModel.decorationMethod.selectedColors.indexOf(color)

    imprintMethodModel.decorationMethod.selectedPmsColors.splice(index, 1)
    imprintMethodModel.decorationMethod.selectedColors.splice(
      indexForSelected,
      1
    )
    state.pmsMatch.splice(0)
    state.pmsSearch = ''
  } else {
    emit(
      'max-color-error',
      'Max ' +
        imprintMethodModel.decorationMethod.MaxColors +
        ' Imprint colors.'
    )
  }

  emit('click')
}

const onRemoveSelectedColor = (color: PMSColor) => {
  const { imprintMethodModel } = props

  let index = imprintMethodModel.decorationMethod.selectedColors.indexOf(color)
  if (index !== -1) {
    imprintMethodModel.decorationMethod.selectedColors.splice(index, 1)
  }
  index =
    imprintMethodModel.decorationMethod.selectedStandardColors.indexOf(color)
  if (index !== -1) {
    imprintMethodModel.decorationMethod.selectedStandardColors.splice(index, 1)
  }
  index = imprintMethodModel.decorationMethod.selectedPmsColors.indexOf(color)
  if (index !== -1) {
    imprintMethodModel.decorationMethod.selectedPmsColors.splice(index, 1)
  }

  emit('click')
}

const onEnterPms = (ev: Event) => {
  var obj = ev.target as HTMLInputElement
  // 先把搜索结果删掉
  state.pmsMatch.splice(0)
  var colorCode = obj.value
  if (colorCode.length < 3) {
    return
  }

  var arr = pmsColorList.filter((item, index) => {
    if (item.Name.toLowerCase().indexOf(colorCode) !== -1) return true
    return false
  })

  for (var i = 0; i < arr.length; i++) {
    state.pmsMatch.push(arr[i])
    if (i >= 10) break
  }
}

const onRemovePmsColor = (color: PMSColor) => {
  const { imprintMethodModel } = props

  const index =
    imprintMethodModel.decorationMethod.selectedPmsColors.indexOf(color)
  const indexForSelected =
    imprintMethodModel.decorationMethod.selectedColors.indexOf(color)

  imprintMethodModel.decorationMethod.selectedPmsColors.splice(index, 1)
  imprintMethodModel.decorationMethod.selectedColors.splice(indexForSelected, 1)

  emit('click')
}
</script>
<style lang="less">
.imprint-color {
  padding: 0 !important;
  font-size: 13px;
  color: #4e4e4e;
  margin-top: 0;
  &__colors {
    display: flex;
  }

  &__left {
    width: 300px;
    strong {
      font-weight: 500;
      font-size: 13px;
    }
  }
  &__right {
    vertical-align: top;
    strong {
      font-weight: 500;
      font-size: 13px;
    }
  }
  &__list {
    padding: 0 10px;
  }
  .color-item {
    display: block;
    cursor: pointer;
    margin: 2px;
    float: left;
    width: 30px;
    height: 30px;
    padding: 2px;
    border: 1px solid #bebdbd;
    box-sizing: content-box;
    &.is-active {
      border-color: red !important;
      border-width: 2px !important;
      padding: 1px !important;
      &:hover .close {
        width: 19px;
        height: 19px;
        margin-left: -9px;
        position: absolute;
        top: 20%;
        left: 50%;
        display: block !important;
        float: left;
      }
    }
  }
  &__more-color {
    text-align: right;
    button {
      color: #4596ca;
      cursor: pointer;
      font-size: 15px;
    }
  }
  &__selected-color {
    .fs-13 {
      font-size: 1.3rem;
    }
    .table {
      margin-top: 8px;
      max-width: 470px;
      min-width: 200px;
      display: table;
      .table-td {
        padding: 5px !important;
      }

      .td-spec-img {
        width: 30px;
        .color-item {
          height: 20px;
          width: 20px;
        }
      }
      .td-spec-btn {
        width: 50px;
      }
    }
    .color-item {
      cursor: default;
      padding: 2px;
      border: 1px solid #bebdbd;
      box-sizing: content-box;
    }
  }
  .color-item,
  &__selected-color .color-item {
    &.size20x20 {
      .color-thumb {
        width: 20px;
        height: 20px;
      }
    }
    .color-thumb {
      display: block;
      position: relative;
      width: 30px;
      height: 30px;
      border: none;
      outline: none;
      cursor: pointer;
    }
  }

  .pms-color-input {
    border-color: #cdcdcd;
    border-style: solid;
    border-width: 1px;
    padding: 5px;
    width: 160px;
    line-height: 24px;
    display: block;
    margin-top: 2px;
    height: 34px;
    margin-left: 1px;
    outline: none;
  }
  .pms-color-list {
    width: 161px;
    overflow: hidden visible;
    border: 1px solid #eaeaea;
    background-color: #fff;
    position: absolute;
    z-index: 10;
  }
  .pms-color-selected-list {
    margin-top: 12px;
    width: 153px;
  }
  .pms-color-item {
    width: 100%;
    height: 30px;
    border-right: 0;
    border-bottom: 1px solid #ddd;
    border-left: 0;
    border-image: initial;
    border-top: none;
    display: flex;
    .color {
      display: inline-block;
      cursor: pointer;
      position: relative;
      top: 18%;
      margin-left: 7px;
      margin-bottom: auto;
      width: 20px;
      height: 20px;
      border: 1px solid #ddd;
    }
    .title {
      font-size: 13px;
      display: inline-block;
      line-height: 30px;
      height: 30px;
      overflow: hidden;
      cursor: pointer;
      width: 100px;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding-left: 5px;
    }
  }
  .pms-color-tips {
    font-size: 11px;
    line-height: 1.5;
    text-align: center;
  }
}
</style>
